import { isSessionActive } from './sessionActivity';

/** hls.js: cookie stream_t verso livestreaming (Domain=.hightek.it). */
export function hlsXhrWithCredentials(xhr) {
    xhr.withCredentials = true;
}

export function startLiveStreamCookieRefresh(apiClient, options = {}) {
    const intervalMs = Math.max(30000, Number(options.intervalMs) || 120000);
    let stopped = false;
    let inFlight = false;

    const refresh = (serial) => {
        if (stopped || inFlight || !isSessionActive() || !apiClient) {
            return Promise.resolve(false);
        }
        inFlight = true;
        const path = serial
            ? `/datalive/live-token/${encodeURIComponent(serial)}`
            : '/datalive/live-token';
        return apiClient.get(path)
            .then(() => true)
            .catch(() => false)
            .then((ok) => {
                inFlight = false;
                return ok;
            });
    };

    refresh();
    const intervalId = setInterval(() => refresh(), intervalMs);

    return () => {
        stopped = true;
        clearInterval(intervalId);
    };
}
